module.exports = __webpack_public_path__ + "static/media/piggy_riches_megaways.redtiger.6fb77fd3.jpeg";